import { useRunPayrollDataContext } from 'components/RunPayroll/contexts/RunPayrollDataContext';
import permissions from 'constants/permissions';
import { useIsPayPtEnabled } from './useIsPayPtEnabled';
import useHasPermission from 'utils/useHasPermission';

export const useCanViewComplianceActions = () => {
  const data = useRunPayrollDataContext();
  const isAuthorizedToExecute = useHasPermission([permissions.PAYROLL_EXECUTION]);

  const isPayPtOnRunPayrollEnabled = useIsPayPtEnabled();

  return isPayPtOnRunPayrollEnabled && data
    ? data.isPayrollFinalized && isAuthorizedToExecute
    : false;
};
